import React from 'react';
import ReactDOM from 'react-dom/client';
import './app.css';
import App from './App';
import InvitacionPliego from './components/InvitacionPliego';

// Enrutamiento top-level muy simple · sin react-router.
// - /invitacion/:token → pantalla pública de registro por invitación al pliego.
// - todo lo demás      → App (autenticación + navegación normal).
function AppRoot() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  if (/^\/invitacion\//i.test(path)) {
    return <InvitacionPliego />;
  }
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><AppRoot /></React.StrictMode>);
